<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Account Transactions
            <v-spacer></v-spacer>
            <ReturnHomeBtn />
            <AccountCreditChip />
            <!-- <v-chip v-if="accountCredit > 0" pill color="primary">Credit Amount ${{ accountCredit }}</v-chip> -->
          </v-card-title>
          <v-card-subtitle v-if="isAdmin">{{ account.firstName}} {{ account.lastName }}</v-card-subtitle>
          <v-data-table
            :loading="!transactions"
            loading-text="Loading... Please wait"
            :headers="headers"
            :items="transactions"
            :expanded.sync="expanded"
            show-expand
          >
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">Notes: {{ item.notes }}</td>
            </template>
            <template v-slot:item.createdDate="{ item }">{{ item.createdDate | formatDateTime }}</template>
            <template v-slot:item.amount="{ item }">${{ item.amount }}</template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { errorMessageMixin } from "../shared";
import ReturnHomeBtn from "../components/ReturnHomeBtn.vue";
import AccountCreditChip from "../components/AccountCreditChip.vue";

export default {
  name: "Transactions",
  mixins: [errorMessageMixin],
  components: { ReturnHomeBtn, AccountCreditChip },

  async created() {
    console.log("transactions of ", this.account);
    await this.loadTransactions(this.account.id);
    // await this.loadAccountCredit(this.account.id);
  },
  data() {
    return {
      headers: [
        { text: "Created Date", value: "createdDate", align: "start" },
        { text: "Receipt Number", value: "receiptNumber" },
        { text: "Amount", value: "amount" },
        { text: "ExamRegistrationIds", value: "examRegistrationIdCsv" },
        { text: "", value: "data-table-expand" }
      ],
      expanded: []
      // accountCredit: 0
    };
  },
  computed: {
    ...mapState(["account", "transactions"]),
    ...mapGetters(["isAdmin"])
  },
  methods: {
    ...mapActions(["getTransactionsAction", "logout"]),
    async loadTransactions(id) {
      try {
        await this.getTransactionsAction({
          id: id,
          token: this.$store.state.token
        });

        if (this.$store.state.transactions == null) {
          this.logout();
          console.log("im logged out");
          this.$router.go();
        }
      } catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
    }
  }
};
</script>